<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4 class="card-title" style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;">
      <a href="/faq" style="color:#010101 !important;">FAQ</a>:Snakes Biology & Ecology
    </h4>
    <div class="container">
      <div class="row">
        <div class="col-md-4" style="text-align:justify;">
          <img src="../assets/main-left-image.jpg" width="100%" height="auto" />
          <br />
          <br />
        </div>
        <div class="col-md-8">
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion1
                variant="secondary"
                style="text-align:left;"
              >
                How many species of snakes are found in India?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion1"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >There are more than 300 species of snakes found across India. Even though we feel that nature can possibly hold no more secrets, scientists do discover new species from time to time during detailed studies of snakes in the wild.</b-collapse>
          </b-card>
          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion2
                variant="secondary"
                style="text-align:left;"
              >
                Which part of India has the most number of snakes?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion2"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >Well, there is no clear answer to this question as snakes can be found in almost every corner of India except in places where the average ambient temperature is extremely low. As far as species of snakes go, the Western Ghats and forests of Northeast India have the highest species diversity within India.</b-collapse>
          </b-card>

          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab" style="text-align:left;">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion3
                variant="secondary"
                style="text-align:left;"
              >
                Which is the biggest and smallest snake found In India?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion3"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >
              The reticulated python (Malayopython reticulatus) which is found in Northeast India and the Andaman & Nicobar Islands is the biggest snake found in India. They can grow to over 25 feet in length. The king cobra (Ophiophagus hannah) which is found in many parts of the country is the largest venomous snake found in the world.
              <br />
              <br />
The worm snakes are the smallest snakes found in India. They are often mistaken for earthworms as they are just a few centimeters long and often found in the loose soil in gardens and feed on eggs, larvae and pupae of ants and termites.
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion4
                variant="secondary"
                style="text-align:left;"
              >
                What is the importance of snakes in our eco-system?
                <span
                  class="when-opened"
                  style="float:right;"
                >
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion4"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >Snakes are predators and they are good pest control agents as they feed on rodents like rats and mice. These rodents can cause a lot of damage to stored food grains. The presence of snakes like cobra and rat snakes in farmland will keep these harmful pests under control.</b-collapse>
          </b-card>

          <b-card no-body class="mb-1" style="text-align: left;">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn
                block
                href="#"
                v-b-toggle.accordion5
                variant="secondary"
                style="text-align:left;"
              >
                What is the food of snakes?
                <span class="when-opened" style="float:right;">
                  <font-awesome-icon icon="minus-square" />
                </span>
                <span class="when-closed" style="float:right;">
                  <font-awesome-icon icon="plus-square" />
                </span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="accordion5"
              role="tabpanel"
              style="padding-left: 10px;
    padding-right: 10px;"
            >All the snakes are carnivores – they eat other living things. Depends on the size, habitat of the snake the food very from termites to mammals like deer. Blind snakes which are small burrowing snakes eat insect larva, eggs and termites as their food. Snakes which are found in water or marshy areas hunt fish or frogs for food. Cobras and rat snakes are good rodent controllers whose preferred food is rats. King cobras prefer other snakes as food, but also hunt monitor lizards. The largest snakes found in India are pythons which hunt larger animals like deer or peacocks. The Indian egg eater is the egg specialist which eats bird eggs by raiding nests. The hunting methods of snakes differ from species to species – the venomous snakes depend on their venom to immobilize the prey and the constrictors are ambush predators who will depend on their physical strength to restrain the prey. Snakes are limbless creatures, so they swallow their prey fully including hair, skin and feather etc.. Usually after a heavy meal snakes take few days to week digest the food.</b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
    };
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #ffffff;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #785432;
  border-color: #785432;
}
.btn-secondary {
  color: #fff;
  background-color: #785432;
  border-color: #785432;
}
.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #785432;
  border-color: #785432;
}
</style>